<script>
  import ExpandableIcon from "$lib/components/ExpandableIcon.svelte";

  export let data;
  export let isOpen = false;
  export let ariaLabel = "";
</script>

<button
  id="dropdown-menu-trigger-{data.fields.trigger?.sys?.id}"
  class="flex flex-row w-full items-center justify-between px-24 py-16 lg:px-16 lg:py-8 menu-trigger"
  on:click
  aria-haspopup={true}
  aria-expanded={isOpen}
  aria-labelledby={ariaLabel}
>
  {data.fields.trigger?.fields?.text}
  <span class="pl-8">
    <ExpandableIcon {isOpen} />
  </span>
</button>
